import { render } from "./PanAmerican.vue?vue&type=template&id=b291d7a8&scoped=true"
import script from "./PanAmerican.vue?vue&type=script&lang=js"
export * from "./PanAmerican.vue?vue&type=script&lang=js"

import "./PanAmerican.vue?vue&type=style&index=0&id=b291d7a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b291d7a8"]])

export default __exports__